<template>
  <el-dialog
      id="oow-modal"
      :visible.sync="visible"
      :close-on-click-modal="false"
      custom-class="custom-dialog-class"
      class="dialog-big oow-modal">
    <div
        slot="title"
        class="el-dialog__title">
      <h2> {{ action }} Eligibility Restriction Detected</h2>
      <p> One or more restrictions prevent this action:</p>
    </div>
    <device-restriction-details
        class="device-restriction-details"
        :warranty-ends-at="warrantyEndsAt"
        :oow-reason="oowReason"
        :restrictions="restrictions" />

    <div
        v-if="bypassAllowed"
        class="bypass-warranty">
      <p><strong>Bypass Restriction</strong></p>
      <el-select
          v-model="selectedBypassReason"
          placeholder="Select reason for bypass..."
          name="bypass_reason">
        <el-option
            v-for="reason in reasons"
            :key="reason"
            :label="reason"
            :value="reason">
          <span style="float: left">{{ reason }}</span>
        </el-option>
      </el-select>
    </div>

    <div class="footer">
      <el-button
          v-if="bypassAllowed && selectedBypassReason"
          ref="bypassButton"
          class="button-confirm-replacement"
          type="primary"
          :disabled="!selectedBypassReason"
          @click="bypass()">
        Bypass Warranty Requirement
      </el-button>
      <el-button
          ref="closeButton"
          type="default"
          @click="close()">
        {{ bypassAllowed ? "Cancel" : "Close" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import DeviceRestrictionDetails from "../../components/Shared/DeviceRestrictionDetails.vue";
import { DeviceWarrantyAndEligibilityPolicy } from "@/helpers/DeviceWarrantyAndEligibilityPolicy";

export default {
  name: "OutOfWarrantyWarningModal",
  components: {
    DeviceRestrictionDetails,
  },
  props: {},
  data() {
    return {
      visible: false,
      bypassAllowed: false,
      warrantyEndsAt: null,
      oowReason: null,
      reasons: [
        "Ring Assist +",
        "Systems Issue",
        "Ongoing, Unresolved Issue",
        "Theft",
        "Specialty Teams Exception (NA, S2T2, NSE, Trending Only)",
      ],
      selectedBypassReason: null,
      bypassAccepted: false,
      eligibility: DeviceWarrantyAndEligibilityPolicy.create(null),
      serviceType: "",
      callback: () => {},
    };
  },
  computed: {
    action() {
      return this.serviceType
        ? this.serviceType.charAt(0).toUpperCase() + this.serviceType.slice(1)
        : "";
    },
    restrictions() {
      return this.eligibility?.isNullObject
        ? []
        : this.eligibility[this.action.toLowerCase()]?.ineligibilityReasons ||
            [];
    },
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit("on-cancel");
    },
    /**
     * @param {String} serviceType - "parts" or "refund"
     * @param {DeviceWarrantyAndEligibilityPolicy} eligibility
     * @param {Function} callback - Method to be called after bypass is confirmed
     */
    show(serviceType, eligibility, callback) {
      const { warranty } = eligibility;
      this.eligibility = eligibility;
      this.callback = callback;

      this.bypassAccepted = false;
      this.selectedBypassReason = null;

      this.visible = true;
      this.warrantyEndsAt = warranty.standardExpiration;
      this.oowReason = warranty.notes;
      this.serviceType = serviceType;

      this.bypassAllowed = Boolean(
        eligibility[this.action.toLowerCase()]?.isUserAllowed
      );
    },
    bypass() {
      this.visible = false;
      this.callback(this.selectedBypassReason);
    },
  },
};
</script>



<style lang="scss" scoped>
#oow-modal .el-dialog .el-dialog__header {
  margin-left: 7em !important;
}

.device-restriction-details {
  margin-left: 4.5em;
  margin-top: 7.5em;
}

.el-dialog__wrapper.dialog-big.oow-modal {
  width: 70% !important;
  margin: auto !important;
  .el-dialog {
    max-width: 800px !important;
    border-radius: 16px !important;
    text-align: center !important;
    .el-dialog__header {
      background-color: #1ad6fd;
      .el-dialog__title {
        position: absolute;
        margin-left: 3em;
        h2 {
          padding: 55px 0 10px;
          font-size: 36px;
          margin: 0;
        }
        p {
          color: #d71b00;
          margin: 0;
          font-size: 20px;
          font-weight: 500;
        }
      }
    }
    .el-dialog__body {
      padding: 40px !important;
      .el-alert {
        max-width: fit-content;
        text-align: left;
        display: inline-block;
        background: #eaeaea;
        font-size: 0.9em;
        padding: 16px 15px;
        margin-top: 5px;
        margin-left: 1em;
        .el-alert__content {
          display: inline-block !important;
          .el-alert__description {
            font-size: 18px;
            padding: 10px;
          }
        }
      }
      p {
        font-size: 0.9em;
        text-align: left;
        //padding-left: 1em;
      }
    }
    .bypass-warranty {
      margin-bottom: 20px;
      margin-left: 4.3em;
      margin-right: 4em;
      p {
        margin: 2em 0 5px;
        font-size: 18px !important;
      }
      .el-input {
        max-width: 75%;
        margin-left: 1em;
      }
    }
    .footer {
      text-align: right;
      padding: 10px 0px;
      margin-right: 4em;
    }
    .button-confirm-replacement {
      border: 1px solid #d71b00;
      color: #d71b00;
      background: #fff;
      &:hover {
        background: #d71b00;
        color: #fff;
      }
    }
  }
}
</style>
